import { Injectable } from '@angular/core';
import { MyHttpClient } from '../http-client';

@Injectable({
  providedIn: 'root'
})
export class CaptainShareRideService {
  private trackUrl = process.env.SERVER + '/api/captain/track/';

  constructor(private http: MyHttpClient) {}

  getCaptainTrackingData(trackId: string) {
    return this.http.get(this.trackUrl + trackId);
  }
}
